
export function hashObject(obj) {
  if(!obj) return '{}';

  return Object.keys(obj).reduce((memo, key) => {
    return memo + key + JSON.stringify(obj[key]);
  }, '');
}

export function cachePromise(request) {
  const cache = {};

  return (params) => {
    const cacheKey = hashObject(params);

    if(cache[cacheKey]) {
      return cache[cacheKey];
    } else {
      const promise = request(params);
      // refactor?
      cache[cacheKey] = promise;

      // jquery ajax requests in our old version don't have `catch`
      if (promise.catch) {
        promise.catch(() => {
          delete cache[cacheKey];
        });
      } else {
        promise.fail(() => {
          delete cache[cacheKey];
        });
      }
      return promise;
    }

  };
}

export default cachePromise;
